import React, { useEffect, useRef, useState } from 'react';
import { GlobalOutlined } from '@ant-design/icons';
import { useI18n } from './I18nContext';
import './LanguageSwitcher.css';

type Props = {
  className?: string;
};

const LanguageSwitcher: React.FC<Props> = ({ className }) => {
  const { locale, setLocale, locales } = useI18n();
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  const current = locales.find((l) => l.code === locale) || locales[0];

  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      if (!rootRef.current?.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div className={`lang-switcher ${className || ''}`} ref={rootRef}>
      <button
        type="button"
        className="lang-switcher-trigger"
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <GlobalOutlined />
        <span className="lang-switcher-code">{current.code.toUpperCase()}</span>
      </button>
      {open && (
        <ul className="lang-switcher-menu" role="listbox">
          {locales.map((item) => (
            <li key={item.code}>
              <button
                type="button"
                role="option"
                aria-selected={item.code === locale}
                className={`lang-switcher-option ${item.code === locale ? 'active' : ''}`}
                onClick={() => {
                  setLocale(item.code);
                  setOpen(false);
                }}
              >
                <span className="lang-switcher-option-native">{item.nativeLabel}</span>
                <span className="lang-switcher-option-code">{item.code}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;
